import * as colors from "./palette";

export interface ITheme {
    name: string;

    fontSizes: IFontSizes;

    // main context (currently, the only colors that change when switching theme)
    backgroundPage: string;
    background1: string;
    background2: string;
    foreground: string;
    foregroundTitle: string;

    // branding context
    brandDeep: string;
    brandMedium: string;
    brandKey: string;
    brandHighlight: string;
    brandForeground: string;

    // neutral context
    neutral1: string;
    neutral2: string;
    neutralForeground: string;

    // success context
    success1: string;
    success2: string;
    successForeground: string;
    successLowlight: string;

    // danger context
    danger1: string;
    danger2: string;
    dangerForeground: string;

    // misc
    shadow: string;
    error: string;
    highlight: string;

    // persons
    persons: string[];
    personForeground: string;
    personUnassigned: string;
}

interface IFontSizes {
    tiny: number;
    small: number;
    medium: number;
    large: number;
    veryLarge: number;
}

const fontSizes: IFontSizes = {
    tiny: 11,
    small: 12,
    medium: 14,
    large: 16,
    veryLarge: 18
};

const persons: string[] = [
    colors.purple1,
    colors.purple2,
    colors.green1,
    colors.green2,
    colors.yellow,
    colors.midBlue,
    colors.amber1,
    colors.hotPink
];

const sameColors = {
    brandDeep: colors.darkBlue,
    brandMedium: colors.mediumBlue,
    brandKey: colors.brightBlue,
    brandHighlight: colors.cyan,
    brandForeground: colors.white,

    neutral1: colors.lightGrey1,
    neutral2: colors.veryLightGrey,
    neutralForeground: colors.darkBlue1,

    success1: colors.green1,
    success2: colors.green2,
    successForeground: colors.white,
    successLowlight: colors.darkGreen1,

    danger1: colors.red1,
    danger2: colors.red2,
    dangerForeground: colors.white,

    shadow: colors.black,
    error: colors.amber1,
    highlight: colors.mustardYellow,

    persons,
    personForeground: colors.white,
    personUnassigned: colors.lightGrey1
};

export const lightTheme: ITheme = {
    name: "light",
    fontSizes,
    backgroundPage: colors.pageBackground,
    background1: colors.white,
    background2: colors.lightGrey1,
    foreground: colors.darkGrey,
    foregroundTitle: colors.darkBlue,
    ...sameColors
};

export const darkTheme: ITheme = {
    name: "dark",
    fontSizes,
    backgroundPage: colors.black,
    background1: colors.darkBlue1,
    background2: colors.darkBlue2,
    foreground: colors.white,
    foregroundTitle: colors.lightBlue1,
    ...sameColors
};

export const themeRegistry = [lightTheme, darkTheme];
